module.exports = __webpack_public_path__ + "static/media/deloitte.2846204c.png";